import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TabsPage } from './tabs.page';

import { BrowserHomePageGuard } from '../../core/guards/browser-home-page.guard';
import { HomePageVendorsGuard } from '../../core/guards/home-page-vendors.guard';
import { HomePageGuard } from '../../core/guards/home-page.guard';
import { NoEntryPageCordovaGuard } from '../../core/guards/no-entry-page-cordova.guard';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'vendors/home',
        canActivate: [HomePageGuard],
        data: { title: 'PAGES.HOME' },
        loadChildren: () => import('../home/home.module').then((m) => m.HomePageModule),
      },
      {
        path: 'vendors/search',
        canActivate: [NoEntryPageCordovaGuard, HomePageVendorsGuard],
        data: { title: 'PAGES.SEARCH' },
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('../vendors-home/vendors-home.module').then((m) => m.VendorsHomePageModule),
      },
      {
        path: 'contact',
        data: { title: 'PAGES.CONTACT_US' },
        loadChildren: () => import('../contact/contact.module').then((m) => m.ContactPageModule),
      },
      {
        path: 'account',
        data: { title: 'PAGES.MY_PROFILE' },
        loadChildren: () => import('../account/account.module').then((m) => m.AccountPageModule),
      },
      {
        path: '**',
        canActivate: [BrowserHomePageGuard],
        loadChildren: () => import('../browser-home/browser-home.module').then((m) => m.BrowserHomePageModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule {}
